export default __webpack_public_path__ + "static/media/Mask of the Precursor.65d24238.jpg";